import {initialSessionState, ISessionState} from '@app/core/store/state/session.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {ESessionActions, SessionActions} from '@app/core/store/actions/session.actions';
import {User} from '@app/core/models/user.model';
import {DepartmentSettingsActions, EDepartmentSettingsActions} from '@app/core/store/actions/department-settings.actions';

export const sessionReducers = (
	state = initialSessionState,
	action: SessionActions | ErrorActions | DepartmentSettingsActions,
): ISessionState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESessionActions.GetSession: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.GetSessionSuccess: {
			return {
				...state,
				isLoading: false,
				user: action.user,
				departments: action.departments,
				department: action.department,
			};
		}
		case ESessionActions.SetTenant:
		case EDepartmentSettingsActions.SetTenant:
		case EDepartmentSettingsActions.GetTenantSuccess:
		case EDepartmentSettingsActions.PatchTenantSuccess: {
			return {
				...state,
				isLoading: false,
				tenant: action.tenant,
			};
		}
		case ESessionActions.SetUser: {
			return {
				...state,
				user: action.user,
			};
		}
		case ESessionActions.SetDepartment: {
			return {
				...state,
				department: action.department,
			};
		}
		case ESessionActions.SetDepartments: {
			return {
				...state,
				departments: action.departments,
			};
		}
		case ESessionActions.SetNewPassword: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.SetNewPasswordSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESessionActions.GetDepartments: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.GetDepartmentsSuccess: {
			return {
				...state,
				departments: action.departments,
				isLoading: false,
			};
		}
		case ESessionActions.GetTenants: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.GetTenantsSuccess: {
			return {
				...state,
				tenants: action.tenants,
				isLoading: false,
			};
		}
		case ESessionActions.GetTenantsList: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.GetTenantsListSuccess: {
			return {
				...state,
				tenants: action.tenants,
				isLoading: false,
			};
		}
		case ESessionActions.ClearTenants: {
			return {
				...state,
				tenants: [],
			};
		}
		case ESessionActions.PunchLogin: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.PunchLoginSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESessionActions.SetNewUser: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.SetNewUserSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESessionActions.RegisterTenant: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.RegisterTenantSuccess: {
			return {
				...state,
				isLoading: false,
				registrationComplete: true,
			};
		}
		case ESessionActions.UpdateCurrentUser: {
			const currentUser: User = state.user;
			currentUser.birth_date = action.user.birth_date;
			currentUser.phone_ext = action.user.phone_ext;
			currentUser.profile_picture = action.user.profile_picture;
			currentUser.first_name = action.user.first_name;
			currentUser.language = action.user.language;
			currentUser.last_name = action.user.last_name;
			currentUser.phone_number = action.user.phone_number;
			currentUser.email = action.user.email;

			return {
				...state,
				user: currentUser,
			};
		}
		case ESessionActions.SendForgotPassword: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.SendForgotPasswordSuccess: {
			return {
				...state,
				tenants: [],
				departments: [],
				isLoading: false,
			};
		}
		case ESessionActions.Login: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.LoginSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case ESessionActions.ClearSession: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.ClearSessionSuccess: {
			return initialSessionState;
		}

		case ESessionActions.SetUserType: {
			return {
				...state,
				userType: action.userType,
			};
		}

		case ESessionActions.GetHubChainSuccess: {
			return {
				...state,
				hub_chain: action.hub_chain,
			};
		}
		case ESessionActions.GenerateTokenAndNavigateToModule: {
			return {
				...state,
				isLoading: true,
			};
		}
		case ESessionActions.GenerateTokenAndNavigateToModuleSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		default:
			return state;
	}
};
